var formWait = setInterval(() => {
    let gclidInput = document.getElementById('gclid');

    if (gclidInput !== null) {

      clearInterval(formWait);

      const cookieValue = document.cookie.split("; ").find((row) => row.startsWith("_gcl_aw="))?.split("=")[1];
        
      if ((cookieValue !== null && cookieValue !== undefined && cookieValue != '') && (gclidInput.value === null || gclidInput.value === '')) {
        let formattedCookie = cookieValue.split(".")[2];
        gclidInput.value = formattedCookie;
      }

    }
  }, 100);